import setHighestPriorityPackage from "./setHighestPriorityPackage"
import getAvailability from "./getAvailability"
import getPrice from "./getPrice"
import getWiypPrice from "./getWiypPrice"
import getLanguageFromLocale from "./getLanguageFromLocale"
import getSiteFromDomain from "./getSiteFromDomain"
import {wiypFeature} from "@/config/ABTestFeatures"
import { wiypActive } from '@/config/ABTestExperiments';
import { wiypCookie } from "@/config/ABTestExperimentConfig"

// Logic
import isABTestActive from "@/logic/isABTestActive"


import Cookies from "js-cookie"


const searchPrestationsForFilter = async (storeObj: any) => {
    const { state, commit, dispatch } = storeObj;
    if (state.productUnavailable) return;

    try {
        dispatch("setLoading", true);
        commit("setQuoteRequestsFinishedLoading", false);

        // Asynchronously fetch availability data
        const availabilityPromise = getAvailability(
            state.packCode,
            state.dates.BeginDate,
            state.dates.EndDate,
            storeObj
        );

        
        // Wait for availability data to resolve
        const availabilityResponse = await availabilityPromise;

        // Handle price requests based on AB testing conditions
        await handlePriceRequests(state, storeObj);

        dispatch("setLoading", false);

        // Check package availability and adjust if necessary
        const isPackageFromHashAvailable = availabilityResponse?.availablePackages?.some(
            (packageObj) => packageObj.codePackage === state.packCode
        );

        if (availabilityResponse && !isPackageFromHashAvailable) {
            setHighestPriorityPackage(storeObj);
        }
    } catch (error) {
        console.error("Error handling prestation search:", error);
        dispatch("setLoading", false); // Ensure loading is set to false on error
    }
}


// Helper function to format dates from "MM/DD/YYYY" to "YYYY-MM-DD"
function formatDates(date: string): string {
    return date.split('/').reverse().join('-');
}

// Main function to handle price requests based on cookie settings
async function handlePriceRequests(state: any, storeObj: any) {
    
    const site = getSiteFromDomain(new URL(window.location.href).hostname, state.language);

    // We allow wiyp for HS package only if we are on cse.travelski.com
    if ((state.packCode === "HS" && site !== 'cse.travelski.com') || !state.dates.BeginDate || !state.dates.EndDate) {
        console.error("cannot")
        return;
    }

    const beginDate = formatDates(state.dates.BeginDate);
    const endDate = formatDates(state.dates.EndDate);

    if (state.prestMaps && state.prestMaps.seAvailabilities && state.prestMaps.seAvailabilities[state.packCode]) {

        // create a set of the packages to remove duplicates
        
        const prestations = Object.values(state.prestMaps.seAvailabilities[state.packCode])

        const sortedParticipants = state.participants.slice().sort((a: number, b: number) => b - a).join('-');

        await getWiypPrice(
            state.packCode,
            prestations,
            beginDate,
            endDate,
            sortedParticipants,
            site,
            getLanguageFromLocale(state.language),
            storeObj
        );
    }

}

export default searchPrestationsForFilter